import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { messageService } from '../../message.service';

@Component({
  selector: 'app-success-snackbar',
  templateUrl: './success-snackbar.component.html',
  styleUrls: ['./success-snackbar.component.scss']
})
export class SuccessSnackbarComponent implements OnInit {
  msg: any = [];
  messageHistory: any = [];
  str = "";
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, public snackBarRef: MatSnackBarRef<SuccessSnackbarComponent>, private SVC: messageService) {
    if (data.message.includes("ORA") && data.message.includes(":")) {
      this.str = "";
      this.msg = data.message.replace(/ORA\s*-\s*[0-9]*\s*:/g, '');
      // for(let k=0;k<this.msg.length;k++){
      //   if(k==0){

      //   }else{
      this.str += this.msg;
      // }

      //}
      data.message = this.str;
    }
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let d = new Date();
    let day = days[d.getDay()];
    let hr = d.getHours();
    let min: any = d.getMinutes();
    if (min < 10) {
      min = "0" + min;
    }
    let ampm = "am";
    if (hr > 12) {
      hr -= 12;
      ampm = "pm";
    }
    let date = d.getDate();
    let month = months[d.getMonth()];
    let year = d.getFullYear();
    //console.log(date + "-" + month + "-" + year+" "+hr + ":" + min + ampm);
    this.messageHistory.unshift(data);
    this.SVC.message.unshift({
      message: data.message,
      dateTime: date + "-" + month + "-" + year + " " + hr + ":" + min + ampm,
      pageName: data.pageName,
      type: data.type
    });

  }
  ngOnInit(): void {

  }
}
